// The caller's permission list, mirrored for the next first paint.
//
// Kept out of both hooks on purpose: useParticipant writes it (it owns the one
// /aai/me fetch) and usePermissions reads it, so putting it in either would put
// an import cycle between them.
//
// The seed exists because the sidebar paints before /aai/me resolves. Without
// it, a reload draws the nav with no permissions, then redraws it with them,
// and menu items visibly appear a beat later.
//
// It is stamped with the email it belongs to and only read back for that same
// person. Logout clears all storage, but impersonation does not: a consultant
// stepping into one client and then another would otherwise paint the second
// client's nav from the first client's grants.

const SEED_KEY = 'aa_permissions';

interface Seed {
  email: string;
  permissions: string[];
}

function currentEmail(): string {
  try {
    return (localStorage.getItem('user_email') || '').toLowerCase();
  } catch {
    return '';
  }
}

export function readPermissionSeed(): string[] {
  try {
    const raw = localStorage.getItem(SEED_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as Seed;
    if (!parsed || !Array.isArray(parsed.permissions)) return [];
    if ((parsed.email || '').toLowerCase() !== currentEmail()) return [];
    return parsed.permissions.filter((p) => typeof p === 'string');
  } catch {
    return [];
  }
}

export function seedPermissions(permissions: string[] | undefined | null): void {
  try {
    if (permissions && permissions.length) {
      const seed: Seed = { email: currentEmail(), permissions };
      localStorage.setItem(SEED_KEY, JSON.stringify(seed));
      return;
    }
    localStorage.removeItem(SEED_KEY);
  } catch {
    /* storage unavailable: the live list still works, only the seed is lost */
  }
}
